import { ref as r, computed as g } from "vue";
import { useLocale as P } from "./index597.js";
import { parseDate as V, dayOrDaysToDate as h, valueEquals as y, formatter as d } from "./index578.js";
import { isArray as u } from "./index575.js";
import { UPDATE_MODEL_EVENT as C } from "./index584.js";
import E from "./index712.js";
const L = (t, i) => {
  const { lang: n } = P(), f = r(!1), D = r(!1), v = r(null), m = g(() => {
    const { modelValue: e } = t;
    return !e || u(e) && !e.filter(Boolean).length;
  }), s = (e) => {
    if (!y(t.modelValue, e)) {
      let a;
      u(e) ? a = e.map(
        (c) => d(c, t.valueFormat, n.value)
      ) : e && (a = d(e, t.valueFormat, n.value)), i(C, e && a, n.value);
    }
  }, k = g(() => {
    var e;
    let a;
    if (m.value ? o.value.getDefaultValue && (a = o.value.getDefaultValue()) : u(t.modelValue) ? a = t.modelValue.map(
      (l) => V(l, t.valueFormat, n.value)
    ) : a = V(
      (e = t.modelValue) != null ? e : "",
      t.valueFormat,
      n.value
    ), o.value.getRangeAvailableTime) {
      const l = o.value.getRangeAvailableTime(
        a
      );
      E(l, a) || (a = l, m.value || s(h(a)));
    }
    return u(a) && a.some((l) => !l) && (a = []), a;
  }), o = r({});
  return {
    parsedValue: k,
    pickerActualVisible: D,
    pickerOptions: o,
    pickerVisible: f,
    userInput: v,
    valueIsEmpty: m,
    emitInput: s,
    onCalendarChange: (e) => {
      i("calendar-change", e);
    },
    onPanelChange: (e, a, l) => {
      i("panel-change", e, a, l);
    },
    onPick: (e = "", a = !1) => {
      f.value = a;
      let l;
      u(e) ? l = e.map((c) => c.toDate()) : l = e && e.toDate(), v.value = null, s(l);
    },
    onSetPickerOption: (e) => {
      o.value[e[0]] = e[1], o.value.panelReady = !0;
    }
  };
};
export {
  L as useCommonPicker
};
